import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useI18n } from "@/i18n";
import { api } from "@/lib/api";
import { PageHeader, Empty } from "@/components/common";

export default function Billing() {
  const { t, fmtDate, fmtMoney } = useI18n();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/billing/transactions").then((r) => setItems(r.data.items)); }, []);
  return (
    <div data-testid="billing-page">
      <PageHeader title={t("billing.title")} />
      {items && items.length === 0 ? <Empty icon={Receipt} text={t("billing.empty")} /> : (
        <div className="panel overflow-x-auto">
          <Table>
            <TableHeader><TableRow>
              {["date", "type", "amount", "status", "ref"].map((k) => <TableHead key={k}>{t(`billing.${k}`)}</TableHead>)}
            </TableRow></TableHeader>
            <TableBody>
              {items?.map((x) => (
                <TableRow key={x.id} data-testid={`txn-row-${x.id}`}>
                  <TableCell>{fmtDate(x.created_at, true)}</TableCell>
                  <TableCell>{t(`billing.types.${x.type}`)}</TableCell>
                  <TableCell>{fmtMoney(x.amount, x.currency)}</TableCell>
                  <TableCell className={x.status === "success" ? "text-emerald-400" : "text-red-400"}>{t(`billing.statuses.${x.status}`)}</TableCell>
                  <TableCell className="font-mono text-xs">{x.order_ref || x.provider_ref || "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
